module.exports = __webpack_public_path__ + "ba5e7aa9ed8fa3020f6bf1c33d154017.svg";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css-components-src/src/img/android-search-input-icon.svg
// module id = 336
// module chunks = 1